function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import { memo } from 'react';
import PropTypes from 'prop-types';
import { TextInput, TextareaInput, ChoicesInput, SelectInput, QueryCombobox, QuerySelect, RatingsInput, Checkbox, QueryChoices, LinkInput, EditorInput, FileUpload } from "../fields";
import "./styles.scss";

// Local Definitions

// const baseClassName = styleNames.base

const componentClassName = 'form-input';

/**
 * This is the component description.
 */
const FormInput = ({
  className,
  type,
  extraTypes,
  disabled,
  ...otherProps
}) => {
  const newClassName = [className, componentClassName].filter(Boolean).join(' ');
  if (type === 'textarea') {
    return /*#__PURE__*/React.createElement(TextareaInput, _extends({
      className: newClassName,
      disabled: disabled
    }, otherProps));
  }
  if (type === 'multiple') {
    return /*#__PURE__*/React.createElement(ChoicesInput, _extends({
      className: newClassName,
      disabled: disabled,
      multiple: true
    }, otherProps));
  }
  if (type === 'choices') {
    return /*#__PURE__*/React.createElement(ChoicesInput, _extends({
      className: newClassName,
      disabled: disabled
    }, otherProps));
  }
  if (type === 'select') {
    return /*#__PURE__*/React.createElement(SelectInput, _extends({
      className: newClassName,
      disabled: disabled
    }, otherProps));
  }
  if (type === 'query-combobox') {
    return /*#__PURE__*/React.createElement(QueryCombobox, _extends({
      className: newClassName,
      disabled: disabled
    }, otherProps));
  }
  if (type === 'query-select') {
    return /*#__PURE__*/React.createElement(QuerySelect, _extends({
      className: newClassName,
      disabled: disabled
    }, otherProps));
  }
  if (type === 'query-choices') {
    return /*#__PURE__*/React.createElement(QueryChoices, _extends({
      className: newClassName,
      disabled: disabled
    }, otherProps));
  }
  if (type === 'rating') {
    return /*#__PURE__*/React.createElement(RatingsInput, _extends({
      className: newClassName
    }, otherProps));
  }
  if (type === 'checkbox') {
    return /*#__PURE__*/React.createElement(Checkbox, _extends({
      className: newClassName,
      disabled: disabled
    }, otherProps));
  }
  if (type === 'link') {
    return /*#__PURE__*/React.createElement(LinkInput, _extends({
      className: newClassName,
      disabled: disabled
    }, otherProps));
  }
  if (type === 'editor') {
    return /*#__PURE__*/React.createElement(EditorInput, _extends({
      className: newClassName,
      disabled: disabled
    }, otherProps));
  }
  if (type === 'file') {
    return /*#__PURE__*/React.createElement(FileUpload, _extends({
      className: newClassName,
      disabled: disabled
    }, otherProps));
  }
  if (extraTypes?.[type]) {
    const Component = extraTypes[type];
    return /*#__PURE__*/React.createElement(Component, _extends({
      className: newClassName,
      disabled: disabled
    }, otherProps));
  }
  return /*#__PURE__*/React.createElement(TextInput, _extends({
    className: newClassName,
    disabled: disabled,
    type: type
  }, otherProps));
};
FormInput.propTypes = {
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  type: PropTypes.oneOf(['text', 'email', 'password', 'number', 'date', 'datetime', 'month', 'tel', 'hidden', 'select', 'choices', 'textarea', 'query-combobox', 'query-select', 'url', 'rating', 'checkbox',
  // to be removed
  'extendedTypeInput']),
  /**
   * The object with external Input types that would make the form input extensible
   */
  extraTypes: PropTypes.objectOf(PropTypes.func),
  /**
   * Whether the Form input input should be disabled
   */
  disabled: PropTypes.bool
};
FormInput.defaultProps = {
  disabled: false
};
export default /*#__PURE__*/memo(FormInput);